import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { Component as Form } from "@repoflow/form-schema";
import ContentTabs from "@repoflow/components/content-tabs";
import { useSectionContext } from "@repoflow/components/section";
import { usePreview } from "@repoflow/components/preview";
import * as widgets from "widgets/register";
import { useEditorPage } from "../../../context";
import { collectionOptions, TemplateLink } from "../../../blog";
import * as ConfigRoute from "../../config";

// A COLLECTION: which one, and the route of the page that shows one post (for
// the links). The template is the site's, on the blog's Templates tab.
const Collection = () => {
  const { schema, state, attributes } = useSectionContext();
  const { collections } = useEditorPage();
  const preview = usePreview();
  const { values, setValues } = state;
  const config = values.config || {};
  const options = useMemo(() => collectionOptions(collections), [collections]);
  const formConfig = useMemo(
    () => ({
      "/Page/Element/Type/BlogPostCollection": {
        fields: [
          { property: "collectionId", widget: "select", options },
          "postRoute",
        ],
      },
    }),
    [options]
  );

  return (
    <Row>
      <Col>
        <Form
          schema={schema}
          target={{ $ref: "/Page/Element/Type/BlogPostCollection" }}
          widgets={widgets}
          values={config}
          onChange={(mod) => {
            setValues({ ...values, config: mod });
            preview.refresh();
          }}
          config={formConfig}
        />
        {config.collectionId ? (
          <p className="mt-3 mb-0">
            <Link to={`/site/${attributes.siteId}/blog/collection/${config.collectionId}/edit`}>
              Edit this collection
            </Link>
          </p>
        ) : null}
        <TemplateLink siteId={attributes.siteId} kind="collection" />
      </Col>
    </Row>
  );
};

export const Content = () => {
  const tabs = useMemo(
    () => [
      { label: "Collection", content: <Collection /> },
      { label: "Element", content: <ConfigRoute.Content /> },
    ],
    []
  );

  return <ContentTabs tabs={tabs} />;
};
